import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// DELETE /api/admin/portal-content/:id
//
// Pessimistic. Invalidates portalContent.adminList + portalContent.publicAll.
export function useDeletePortalContent() {
  const queryClient = useQueryClient();
  return useMutation<void, ApiClientError, { id: string }>({
    mutationFn: ({ id }) =>
      apiFetch<void>(`/admin/portal-content/${encodeURIComponent(id)}`, {
        method: "DELETE",
      }),
    onError: (err) => {
      toast.error(err.message ?? "Failed to delete portal content");
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.portalContent.adminList(),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.portalContent.publicAll(),
      });
    },
  });
}
